// extracted by mini-css-extract-plugin
export default {"list":"_1qijZhW-","break":"_3BWd6Upb","placeholder":"_3xE5dtup","compactMode":"_20gQlMGZ","beefyMode":"_2dPqlRes","listMode":"_1qEP-Y5Z","squeeze":"sZ2V0eVD"};